import { useState, useCallback } from "react";
import { useAuthenticatedFetchWithWorkspace } from "../../Keycloak/useAuthenticatedFetchWithWorkspace";
import { ListDetails } from "../../../pages/Clients/ListImport/types";

interface GetDetailsCustomersListParams {
    list_id: string | number;
    is_card_list?: string;
}

const useGetDetailsCustomersList = () => {
    const { authFetch } = useAuthenticatedFetchWithWorkspace();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string>("");
    const [data, setData] = useState<ListDetails | null>(null);

    const getDetailsCustomersList = useCallback(async (params: GetDetailsCustomersListParams): Promise<ListDetails | null> => {
        setLoading(true);
        setError("");
        setData(null);

        try {
            let url = `/getDetailsCustomersList?list_id=${params.list_id}`;
            if (params.is_card_list !== undefined && params.is_card_list !== null) {
                url += `&is_card_list=${params.is_card_list}`;
            }
            const result: ListDetails = await authFetch(url, {
                method: "GET",
            });

            if (!result) {
                throw new Error("Failed to retrieve customer list details.");
            }

            setData(result);
            return result;
        } catch (err: unknown) {
            if (err instanceof Error) {
                setError(err.message);
            } else {
                setError("An unknown error occurred");
            }
            return null;
        } finally {
            setLoading(false);
        }
    }, [authFetch]);

    return { getDetailsCustomersList, loading, error, data };
};

export default useGetDetailsCustomersList;
